import { useAnnounceAudioTracks } from "../../application/useAnnounceAudioTracks";

/**
 * Tells the server to look at the room again when a voice joins it, so a
 * participant who arrives late is recorded too. Renders nothing; it only has
 * to live inside the room.
 */
export default function MeetingTrackAnnouncer({
    onAudioPublished,
}: {
    onAudioPublished: () => void;
}) {
    useAnnounceAudioTracks(onAudioPublished);
    return null;
}
